var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.className,style:(_vm.bgColor),attrs:{"size":"size","disabled":_vm.disabled,"block":_vm.blockButton,"dense":true,"dark":true},on:{"click":function($event){return _vm.handleClick()}}},[(_vm.iconBut)?_c('v-icon',{attrs:{"left":""}},[_vm._v("\n    "+_vm._s(_vm.iconBut)+"\n  ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }